import GoogleMapReact from 'google-map-react';
import { observer } from 'mobx-react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { defaultCoordinates } from 'src/constants/map';
import mapStyle from 'src/constants/mapStyle';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import PinIndicator from 'src/view/components/Controls/PinIndicator/PinIndicator';
import branchEditStore from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/store/branchEditStore';
import './style.scss';

const MapPreview = observer((): JSX.Element => {
  const { address, latitude, longitude } = branchEditStore.editableBranch;

  const onClickMap = () => {
    modalStore.openBranchLocationModal({ address, lat: latitude, lng: longitude, onSave: branchEditStore.changeBranchData });
  };

  const positionCoords = latitude && longitude ? { lat: latitude, lng: longitude } : defaultCoordinates;

  return (
    <div className="map-preview" onClick={onClickMap}>
      <GoogleMapReact
        zoom={13}
        bootstrapURLKeys={{
          key: appStore.settings?.google_maps_pk || '',
          libraries: ['geometry'],
        }}
        center={positionCoords}
        yesIWantToUseGoogleMapApiInternals
        options={{
          styles: mapStyle,
          fullscreenControl: false,
          gestureHandling: 'greedy',
          zoomControl: false,
          scrollwheel: true,
          draggable: false,
        }}
      />
      <PinIndicator size={44} className="map-center-icon color-red" name={Icons.Pin} />
      <div className="map-preview__hint">{localeStore.t('click_on_map_to_expand')}</div>
    </div>
  );
});

export default MapPreview;
